import { resolveByCountry } from '@dc/ui-library/src/helpers/environment';

import { toDotFormat, to12HourFormat } from '../../../utils';

const OUR_IDS = [20/* Currys */, 30/* PCWorld */];

/**
 * Format dates in price promise tables
 * @param dateString string date in ISO 8601 format
 * @returns {string} date in format 'at HH xm on DD.MM.YY'
 */
export function formatDate(dateString) {
  // Strip time zone information from the received date,
  // so that we always display the original UK time
  const date = new Date(dateString.replace(/\+.*$/, ''));

  return `at\u00a0${to12HourFormat(date.getHours())} on\u00a0${toDotFormat(date)}`;
}

/**
 * Format prices in price promise tables
 * @param price number
 * @returns {string} price in format '£xx.xx'
 */
export function formatPrice(price) {
  return `${resolveByCountry('£', '€')}${price.toFixed(2)}`;
}

/**
 * Decides whether the store id belongs to one of our stores
 * @param competitorId number
 * @returns {boolean} true if competitorId corresponds to Currys of PCW, false otherwise
 */
export function isOurOffer(competitorId) {
  return OUR_IDS.indexOf(competitorId) !== -1;
}

/**
 * Decides whether the price promise table can be expanded
 * @param fullTable
 * @param isExpanded current state of the table (expanded/collapsed)
 * @param maxRows max number of rows that should be visible in collapsed state
 * @returns {*} true if the table is bigger than maxRows and it is not currently expanded, false
 *              otherwise
 */
export function canExpand(fullTable, isExpanded, maxRows) {
  return !isExpanded && fullTable.length > maxRows;
}

/**
 * Sorts (and collapses) the price promise competitors table
 * @param fullTable
 * @param isExpanded current state of the table (expanded/collapsed)
 * @param maxRows max number of rows that should be visible in collapsed state
 * @returns {*} table, sorted and possibly shortened
 */
export function getDisplayedTable(fullTable, isExpanded, maxRows) {
  return fullTable
    .sort((a, b) => {
      let competitorIdComparison = 0;
      if (isOurOffer(a.competitorId)) competitorIdComparison = -1;
      if (isOurOffer(b.competitorId)) competitorIdComparison = 1;

      const priceComparison = a.price - b.price;

      const nameComparison = a.competitorName
        .toLowerCase()
        .localeCompare(b.competitorName.toLowerCase());

      return competitorIdComparison || priceComparison || nameComparison;
    })
    .slice(0, isExpanded ? fullTable.length : maxRows);
}
